import React, { useEffect, useState } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, CircularProgress, DialogContent, FormControlLabel, List, ListItem, ListItemIcon, Radio, RadioGroup, Divider } from '@mui/material';
import { CANCEL } from '../../constants/buttonConstants';
import { DOWNLOAD_TEXT } from '../../constants/ordersPageConstants';

function DownloadSelectorPopover(props) {

	let { title, subTitle, onClose, open, listData, listSelectAll, listControl } = props;

	const [checked, setChecked] = useState([]);
	const [loading, setLoading] = useState(true);

	const primaryButtonEvent = () => {
		onClose({ 'value': checked });
	};

	const handleClose = () => {
		onClose(null);
	};

	useEffect(() => {
		setChecked([])
	}, [loading])

	useEffect(() => {
		if (open) {
			const timer = setTimeout(() => {
				setLoading(false);
			}, 1000);
			return () => clearTimeout(timer);
		} else {
			setLoading(true)
		}
	}, [open]);

	const handleToggle = (value) => () => {
		const currentIndex = checked.indexOf(value);
		let newChecked = [...checked];

		if (value.label === 'Select All') {
		if (checked.length === listData.length) {
				newChecked = []
			} else {
				newChecked = [...listData]
			}
		}
		else {
			if (currentIndex === -1) {
				newChecked.push(value);
			} else {
				newChecked.splice(currentIndex, 1);
			}
		}

		setChecked(newChecked);
	};

	const handleRadioChange = (event) => {
		setChecked([{ 'value': checked, 'label': event.target.value }]);
	};

	return (
		<>
		{

			<Dialog className='dialog-cont'
			slotProps={{ backdrop: { sx: { backgroundColor: 'rgba(255, 255, 255, 0.8)' } } }}
			sx={{
				borderRadius: '20px',
				'& .MuiDialog-paper': {
				borderRadius: '16px',
				minWidth: '480px',
				maxWidth: '30vw',
				maxHeight: '60vh',
				minHeight: '326px'
				},
				margin: '0 auto'
			}} onClose={handleClose} open={open}>

			{loading && open ? (<>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: 'white', padding: '24px', fontWeight: 700 }} data-testid='download-title'>{title} <CloseIcon sx={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => handleClose()} /></DialogTitle>

				<div className='dialog-cont--loading'><CircularProgress /></div>

			</>) : <>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: 'white', padding: '24px', fontWeight: 700 }} data-testid='download-title'>{title} <CloseIcon sx={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => handleClose()} /></DialogTitle>

				<DialogContent className='dialog-cont--content'>
					<p className='dialog-cont--subtitle'>{subTitle}</p>

				{listData && listControl === 'CheckBox' ? 
					<List 
						className='list'
						sx={{ pt: 0 }}
						aria-labelledby='nested-list-subheader'>
						{listSelectAll ? 
							<ListItem className='list__item' sx={{ width: 'auto', paddingTop: '0px', paddingBottom: '0px' }} key='selectall'>
								<ListItemButton className='list__item__button' role={undefined} onClick={handleToggle({ label: 'Select All', value: false })} dense>
									<ListItemIcon>
										<Checkbox
											edge='start'
											checked={checked.length === listData.length ? true : false}
											indeterminate={checked.length > 0 && checked.length < listData.length}
											tabIndex={-1}
											disableRipple
											inputProps={{ 'aria-labelledby': 'Select All' }}
										/>
									</ListItemIcon>
									<div className='list__item__button'>
										<ListItemText className='list__item__button__label' sx={{ fontSize: 20, fontWeight: 'bolder' }} id='selectall' primary='Select All' />
									</div>
								</ListItemButton>
							</ListItem> : null}

							{listData.map((item, index) => {
								const labelId = `Location item ${item.label}`;
								return (
									<ListItem className='list__item' sx={{ width: 'auto', paddingTop: '0px', paddingBottom: '0px' }} key={index}>
										<ListItemButton className='list__item__button' role={undefined} onClick={handleToggle(item)} dense>
											<ListItemIcon>
												<Checkbox
												edge='start'
												checked={checked.indexOf(item) !== -1}
												tabIndex={-1}
												disableRipple
												inputProps={{ 'aria-labelledby': labelId }}
												/>
											</ListItemIcon>
											<div className='list__item__button'>
												<ListItemText className='list__item__button__label' sx={{ fontSize: 20, fontWeight: 'bolder' }} id={labelId} primary={item.label} />
												<ListItemText className='list__item__button__subLabel' sx={{ fontSize: 16, color: '#aeaeae', fontWeight: 'normal' }} primary={item.subLabel} />
											</div>
										</ListItemButton>
									</ListItem>
								);
							})
						}
					</List> : null
				}


				{listData && listControl === 'Radio' ?
					<RadioGroup defaultValue='' className='list__radioControl' aria-label='Locations' name='customized-radios' onChange={handleRadioChange}>
					{listData.map((item, index) => {
						const labelId = `Type item ${item.label}`;
						return (
						<div key={index}>
							<FormControlLabel sx={{
							height: '54px !important',
							fontFamily: 'Basis Grotesque Pro',
							fontSize: '16px',
							fontWeight: 400,
							lineHeight: '22px',
							textAlign: 'center'
							}}  value={item.label} id={`label${index}`} control={<Radio />} label={item.label} />
							<Divider />
						</div>

						)
					})
					}
					</RadioGroup> : null}

				</DialogContent>
				<div className='pop-over--container--alignright pop-over--container__buttongroup'>
					<button className='pop-over--container--alignright__button pop-over--container--alignright--secondaryButton' onClick={() => handleClose(null)}>{CANCEL}</button>
					<button className='pop-over--container--alignright__button pop-over--container--alignright--primaryButton' disabled={listData?.length > 0 && checked.length === 0} onClick={primaryButtonEvent}>{DOWNLOAD_TEXT}</button>
				</div>
			</>}

			</Dialog>
		}
		</>

	);
}

export default DownloadSelectorPopover;
